import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

// Constants
export const PREPRINT_SELECTED_VERSION_STORAGE_KEY = "local-selected-versions";
const STORAGE_KEY = PREPRINT_SELECTED_VERSION_STORAGE_KEY;
const CARD_PREFIX = "card-";

interface LocalVersionStorage {
	[key: string]: number | null;
}

interface PreprintCardSelectedVersionState {
	versions: LocalVersionStorage;
	setSelectedVersion: (shapeId: string, version: number | null) => void;
	removeAllVersions: () => void;
}

export const usePreprintCardSelectedVersionStore =
	create<PreprintCardSelectedVersionState>()(
		persist(
			(set) => ({
				versions: {},
				setSelectedVersion: (shapeId: string, version: number | null) =>
					set((state) => {
						const storageKey = `${CARD_PREFIX}${shapeId}`;
						return {
							versions: {
								...state.versions,
								[storageKey]: version,
							},
						};
					}),
				removeAllVersions: () => set({ versions: {} }),
			}),
			{
				name: STORAGE_KEY,
				storage: createJSONStorage(() => sessionStorage),
			},
		),
	);
